import { ConnectionIcon } from './ConnectionIcon';

/**
 * author: Michael Irigoyen
 * id C66F7470-8691-4B30-A8F6-5250389E1D48
 * name connection
 * version: 5.6.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/connection.svg
 * tags
 * - Home Automation 
 */
export const PlugIcon = ConnectionIcon;
export default PlugIcon